const ROW_HEIGHT = 40;
const MAX_SHOWN_ROWS = 6;
const SELECT_ROW_HEIGHT = 34;

export const countHeightForList = (allItemsLength: number): number =>
  allItemsLength > MAX_SHOWN_ROWS ? MAX_SHOWN_ROWS * ROW_HEIGHT : allItemsLength * ROW_HEIGHT + SELECT_ROW_HEIGHT;
